import React, { useEffect, useState, useRef } from "react";
import Constants from "../constants/Constants";
import BannedWords from "../constants/BannedWords";
import ChatBubble from "./ChatBubble";
import TipBarDMs from "./TipBarDMs";
import PerfectScrollbar from "perfect-scrollbar";
import { navigate } from "@reach/router";
import Lightbox from "react-image-lightbox";
import "../lightbox.css";
import "../ps.css";
const Conversation = ({ siteid, dispatch, isDesktop, biller }) => {
  const [chat, setChat] = useState([]);
  const [girl, setGirl] = useState({});
  const [slideIndex, setSlideIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [lastID, setLastID] = useState(0);
  const [tipAmount, setTipAmount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [displayTip, setDisplayTip] = useState(false);
  const [showTip, setShowTip] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [tempID, setTempID] = useState(99999);
  const [typedMsg, setTypedMsg] = useState("");
  const [flashError, setFlashError] = useState(false);
  const [pageStatus, setPageStatus] = useState("loading");
  const chatWindow = useRef(null);
  const messageEnd = useRef(null);
  const isLoading = useRef(false);
  const ps = useRef(null);
  const polling = useRef(null);
  useEffect(() => {
    if (!displayTip) {
      setTimeout(() => {
        setShowTip(false);
      }, 450);
    }
  }, [displayTip]);
  useEffect(() => {
    if (images.length > 0) {
      setIsOpen(true);
    }
  }, [images]);

  useEffect(() => {
    const ele = chatWindow.current;
    const maxPer = 10;
    const handleScroll = (event) => {
      if (event.target.scrollTop === 0 && !isLoading.current) {
        isLoading.current = true;
        fetch(
          `${Constants.API}get-messages-from.php?siteid=${siteid}&li=${lastID}`,
          {
            credentials: "include",
          }
        )
          .then((res) => res.json())
          .then((res) => {
            if (res.chat.length > 0) {
              setLastID(res.chat[res.chat.length - 1].id);
            }
            const resReverse = res.chat.reverse();
            resReverse.forEach((item) => {
              if ("mediaLinks" in item) {
                item.mediaLinks.forEach((media) => (new Image().src = media));
              }
            });
            setChat((prev) => [...resReverse, ...prev]);
            if (res.chat.length < maxPer) {
              setIsFinished(true);
              ele.removeEventListener("ps-y-reach-start", handleScroll, false);
            } else {
              isLoading.current = false;
            }
          });
      }
    };
    if (!isFinished) {
      if (ele) {
        ele.addEventListener("ps-y-reach-start", handleScroll, false);
      }
    }

    return () => {
      ele.removeEventListener("ps-y-reach-start", handleScroll, false);
    };
  }, [lastID, siteid, isFinished]);
  useEffect(() => {
    if (siteid === 0) {
      return;
    }
    fetch(`${Constants.API}get-messages-from.php?siteid=${siteid}`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.chat.length > 0) {
          setLastID(res.chat[res.chat.length - 1].id);
        }
        const resReverse = res.chat.reverse();
        resReverse.forEach((item) => {
          if ("mediaLinks" in item) {
            item.mediaLinks.forEach((media) => (new Image().src = media));
          }
        });
        setChat(resReverse);
        setGirl(res.site);
        setPageStatus("reading");
        ps.current = new PerfectScrollbar(chatWindow.current, {
          maxScrollbarLength: 120,
        });
        setTimeout(() => {
          // chatWindow.current.scrollTop = chatWindow.current.scrollHeight;
          messageEnd.current.scrollIntoView();
          setShowChat(true);
        }, 650);
      });
  }, [siteid]);
  const startPolling = (tok, newWindow) => {
    let evtSource = new EventSource(`${Constants.API}mjs.php?tok=${tok}`);
    polling.current = evtSource;

    evtSource.onopen = function() {
      console.log("Checking with the 7 about the new site.");
    };

    evtSource.onmessage = function(e) {
      if (e.data === "SUCCESS!") {
        evtSource.close();
        if (newWindow === null) {
          alert("Success, close the billing tab.");
        } else {
          newWindow.close();
        }

        setChat((prev) => {
          return [
            ...prev,
            {
              id: tempID,
              direction: "from",
              msg: typedMsg,
              created_at: "",
              readable: "just now",
              special: `$${tipAmount} Tip!`,
              unread: "n",
            },
          ];
        });
        setTempID((prev) => prev + 1);
        setTypedMsg("");
        setPageStatus("reading");
        setTipAmount(0);
      } else if (e.data === "STOP!") {
        if (newWindow !== null) {
          newWindow.close();
        }
        evtSource.close();
        setTypedMsg("");
        setPageStatus("reading");
        setTipAmount(0);
        setChat((prev) => {
          return [
            {
              id: tempID,
              site_id: siteid,
              direction: "from",
              msg: typedMsg,
              unread: "n",
              hasError: "Tip Transaction Failed :(",
            },
            ...prev,
          ];
        });
        setTempID((prev) => prev + 1);
      } else {
        console.log("...");
      }
    };

    evtSource.onerror = function() {
      evtSource.close();
      console.log("joined failed.");
    };
  };
  const makePurchase = (newWindow) => {
    let formData = new FormData();
    formData.append("siteid", girl.id);
    formData.append("amount", tipAmount);
    formData.append("msg", typedMsg);
    if (bannWordCheck(typedMsg.toLowerCase())) {
      return;
    }
    fetch(`${Constants.API}attempt-tip.php`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (!("error" in res)) {
          if ("success" in res) {
            setChat((prev) => {
              return [
                ...prev,
                {
                  id: tempID,
                  direction: "from",
                  msg: typedMsg,
                  created_at: "",
                  readable: "just now",
                  special: `$${tipAmount} Tip!`,
                  unread: "n",
                },
              ];
            });
            setTempID((prev) => prev + 1);
            setTypedMsg("");
            setPageStatus("reading");
            setTipAmount(0);
          } else {
            const goTo = `https://wnu.com/secure/services/?api=camcharge&action=authandclose&auth_amount=${res.auth_amount}&member_id=${res.member_id}&include_css=${res.include_css}&returnurl=${res.returnurl}&description=${res.x_description}&pburl=${res.pburl}&x_description=${res.x_description}&x_pkey=${res.x_pkey}&x_site=${res.x_site}&epoch_digest=${res.epoch_digest}`;
            if (newWindow === null) {
              newWindow = window.open(
                goTo,
                "AF_TIP",
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes"
              );
            } else {
              newWindow.location = goTo;
            }
            startPolling(res.x_pkey, newWindow);
          }
        } else {
          if (newWindow) {
            newWindow.close();
          }

          setTypedMsg("");
          setPageStatus("reading");
          setTipAmount(0);
          setChat((prev) => {
            return [
              ...prev,
              {
                id: tempID,
                site_id: siteid,
                direction: "from",
                msg: typedMsg,
                unread: "n",
                hasError: "Your biller does not support tips.",
              },
            ];
          });
          setTempID((prev) => prev + 1);
        }
      })
      .catch((error) => {
        setPageStatus("reading");
        setTipAmount(0);
        setChat((prev) => {
          return [
            ...prev,
            {
              id: tempID,
              site_id: siteid,
              direction: "from",
              msg: typedMsg,
              unread: "n",
              hasError: "Your biller is not tip supported..",
            },
          ];
        });
        setTempID((prev) => prev + 1);
      });
  };
  const bannWordCheck = (the_msg) => {
    let noBannedWords = "";
    for (let i = 0; i < BannedWords.length; i++) {
      if (the_msg.includes(BannedWords[i])) {
        noBannedWords = BannedWords[i];
        break;
      }
    }

    if (noBannedWords !== "") {
      setChat((prev) => {
        return [
          ...prev,
          {
            id: tempID,
            site_id: siteid,
            direction: "from",
            msg: typedMsg,
            unread: "n",
            hasError: `banned word: ${noBannedWords} - message not sent`,
          },
        ];
      });
      setTempID((prev) => prev + 1);
      setTimeout(() => {
        // chatWindow.current.scrollTop = chatWindow.current.scrollHeight;
        messageEnd.current.scrollIntoView();
      }, 650);
      setPageStatus("reading");
      setTipAmount(0);
      setTypedMsg("");
      return true;
    }
    return false;
  };
  const handleSendingMessage = () => {
    if (pageStatus !== "sendingMsg" && typedMsg !== "") {
      setPageStatus("sendingMsg");
      if (tipAmount !== 0) {
        let newWindow = null;
        if (biller !== 14) {
          newWindow = window.open("/robots-working/", "_blank");
        }
        makePurchase(newWindow);
        return false;
      }
      const formData = new FormData();
      formData.append("siteid", siteid);
      formData.append("msg", typedMsg);

      if (bannWordCheck(typedMsg.toLowerCase())) {
        return;
      }

      fetch(`${Constants.API}send-dm.php`, {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {
          "X-XSRF-Header": Constants.XSRF,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if ("error" in res) {
            setChat((prev) => {
              return [
                ...prev,
                {
                  id: tempID,
                  site_id: siteid,
                  direction: "from",
                  msg: typedMsg,
                  unread: "n",
                  hasError: "Subscription REQUIRED for DM's.",
                },
              ];
            });
            setTempID((prev) => prev + 1);
            setTimeout(() => {
              // chatWindow.current.scrollTop = chatWindow.current.scrollHeight;
              messageEnd.current.scrollIntoView();
            }, 650);
            return false;
          }
          setChat((prev) => {
            return [...prev, res];
          });
        });

      setTypedMsg("");
      setPageStatus("reading");
      setTimeout(() => {
        // chatWindow.current.scrollTop = chatWindow.current.scrollHeight;
        messageEnd.current.scrollIntoView();
      }, 650);
    }
  };
  return (
    <div className="chatWindow">
      <div
        className={isOpen ? "chatContainer noscroll" : "chatContainer"}
        ref={chatWindow}
      >
        {flashError ? (
          <div className="flashErrorMessage">
            Message Can't Be longer Then 1000 Characters
          </div>
        ) : null}
        {pageStatus === "loading" ? (
          <div className="loadingChat">Loading...</div>
        ) : (
          <div className={!showChat ? "allBubbles" : "allBubbles noshow"}>
            {chat.map((item, index) => (
              <ChatBubble
                direction={item.direction}
                key={`bbl${item.id}`}
                modelName={girl.site_name}
                msg={item.msg}
                request_type={item.request_type}
                biller={biller}
                index={index}
                special={item.special}
                isLast={index === chat.length - 1}
                siteURL={girl.site_url}
                udp={item.udp}
                ppvid={item.ppv_id}
                mediaLinks={item.media_links}
                requestPrice={item.request_price}
                paid={item.paid}
                payment_id={item.payment_id}
                token={item.token}
                custom_done={item.custom_done}
                fullLinks={item.full_links}
                setImages={setImages}
                mediaLength={parseInt(item.media_length)}
                mediaType={item.media_type}
                setSlideIndex={setSlideIndex}
                readable={item.readable}
                dispatch={dispatch}
                file={item.file_name}
                price={parseInt(item.price)}
                hasError={item.hasError}
              />
            ))}
            <div ref={messageEnd} />
          </div>
        )}
      </div>
      <div className="topLeft">
        <button
          className="goBack"
          onClick={() => navigate(`${Constants.MA}messages`)}
        >
          <i className="icon-arrow-left"></i>
        </button>
        {girl.site_name}
      </div>
      {isOpen ? (
        images.length > 1 ? (
          <Lightbox
            mainSrc={images[slideIndex]}
            nextSrc={images[(slideIndex + 1) % images.length]}
            prevSrc={images[(slideIndex + images.length - 1) % images.length]}
            onCloseRequest={() => {
              setIsOpen(false);
              setImages([]);
            }}
            onMovePrevRequest={() =>
              setSlideIndex((slideIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
              setSlideIndex((slideIndex + 1) % images.length)
            }
          />
        ) : (
          <Lightbox
            mainSrc={images[slideIndex]}
            onCloseRequest={() => {
              setIsOpen(false);
              setImages([]);
            }}
          />
        )
      ) : null}
      <div className="typeBox">
        <div className="typeOptions">
          {siteid !== "9" && (
            <button
              className={tipAmount === 0 ? "dmTip" : "dmTip active"}
              onClick={() => {
                if (tipAmount !== 0) {
                  return false;
                }
                setShowTip(true);
                setTimeout(() => {
                  setDisplayTip(true);
                }, 100);
              }}
            >
              {tipAmount === 0 ? `$` : `$${tipAmount}`}
              {tipAmount === 0 ? null : (
                <span className="cancelTip" onClick={() => setTipAmount(0)}>
                  <i className="icon-close" />
                </span>
              )}
            </button>
          )}

          <textarea
            type="text"
            value={typedMsg}
            className="dmChatInput"
            style={
              !isDesktop && typedMsg.length < 26
                ? null
                : { height: `${Math.floor(typedMsg.length / 26) * 10 + 40}px` }
            }
            onChange={(e) => {
              setTypedMsg(e.target.value);
              if (e.target.value.length > 1000) {
                setFlashError(true);
                setTimeout(() => setFlashError(false), 3000);
              }
            }}
          ></textarea>
          <button className="dmSend" onClick={handleSendingMessage}>
            {pageStatus === "reading" ? (
              <i className="icon-send"></i>
            ) : (
              <div className="nk-spinner" />
            )}
          </button>
        </div>
        {showTip ? (
          <TipBarDMs
            displayTip={displayTip}
            setDisplayTip={setDisplayTip}
            setTipAmount={setTipAmount}
          />
        ) : null}
        {siteid !== "9" && (
          <div className="tipMessage">
            Messages <span>with tips</span> appear at the top of creator's inbox
          </div>
        )}
      </div>
    </div>
  );
};

export default Conversation;
